<section class="admin-tenants">
  <app-page-header
    title="Gestión de Empresas"
    subtitle="Administra las empresas (tenants) del sistema"
    icon="Building2"
  />

  @if (!canManage()) {
    <div class="admin-tenants__denied card-like">
      <p class="admin-tenants__denied-title">Acceso restringido</p>
      <p class="admin-tenants__denied-text">
        Solo el superadministrador puede gestionar empresas.
      </p>
    </div>
  } @else {
    @if (error()) {
      <app-vault-page-alert
        type="error"
        title="Error"
        [message]="error()"
        (closed)="error.set(null)"
      />
    }

    <div class="admin-tenants__toolbar">
      <lib-button variant="primary" type="button" prefixIcon="Plus" [disabled]="loading()" (clicked)="openCreate()">
        Nueva empresa
      </lib-button>
      <lib-button variant="secondary" type="button" prefixIcon="RefreshCcw" [loading]="loading()" (clicked)="reload()">
        Actualizar
      </lib-button>
    </div>

    @if (loading()) {
      <div class="admin-tenants__skeleton" aria-busy="true">
        <lib-skeleton variant="rectangle" [height]="'48px'" />
        <lib-skeleton variant="rectangle" [height]="'48px'" />
        <lib-skeleton variant="rectangle" [height]="'48px'" />
      </div>
    } @else if (tenants().length === 0) {
      <lib-empty icon="Building2" message="Sin empresas" description="No hay empresas registradas." />
    } @else {
      <div class="admin-tenants__table-wrap">
        <lib-search
          placeholder="Buscar por nombre, código o descripción..."
          [searchTerm]="searchTerm()"
          (searchTermChange)="onTableSearchChange($event)"
          [loading]="loading()"
        />
        @if (tableData().length === 0) {
          <lib-empty icon="Search" message="Sin resultados" description="No hay empresas que coincidan con la búsqueda." />
        } @else {
          <lib-table
            [config]="tableConfig()"
            [data]="tableData()"
            [loading]="loading()"
            [searchTerm]="searchTerm()"
            (searchTermChange)="onTableSearchChange($event)"
            [pageSize]="tablePageSize()"
            [pageSizeOptions]="tablePageSizeOptions"
            (pageChange)="onTablePageChange($event)"
            [sortColumn]="tableSortColumn()"
            [sortDirection]="tableSortDirection()"
            (sortChange)="onTableSort($event)"
            (action)="onTableAction($event)"
          >
            <ng-template #cellTemplate let-row let-column="column">
              @if (column.key === 'statusLabel') {
                <lib-badge
                  [text]="row.statusLabel"
                  [variant]="row.is_active ? 'success' : 'neutral'"
                  size="small"
                />
              }
            </ng-template>
          </lib-table>
        }
      </div>
    }
  }
</section>

@if (formOpen()) {
  <div class="admin-tenants__backdrop" (click)="closeForm()" role="presentation"></div>
  <div class="admin-tenants__dialog" role="dialog" aria-modal="true">
    <header class="admin-tenants__dialog-head">
      <h2>{{ formMode() === 'create' ? 'Nueva empresa' : 'Editar empresa' }}</h2>
      <p class="admin-tenants__form-intro">
        {{ formMode() === 'create' ? 'Complete los datos de la nueva empresa.' : 'Actualice los datos de la empresa.' }}
      </p>
    </header>
    <div class="admin-tenants__dialog-body" (click)="$event.stopPropagation()">
      <app-grid-form preset="2cols" [columns]="2" gap="1rem">
        <app-grid-form-item [span]="'full'">
          <app-field-label label="Nombre" [required]="true" [tooltip]="nameFieldTooltip" />
          <lib-input label="" [value]="formName()" (valueChange)="onNameChange($event)" />
        </app-grid-form-item>
        <app-grid-form-item [span]="'full'">
          <app-field-label label="Código de empresa" [required]="true" [tooltip]="slugFieldTooltip" />
          <lib-input label="" [value]="formSlug()" (valueChange)="formSlug.set($event)" />
        </app-grid-form-item>
        <app-grid-form-item [span]="'full'">
          <app-field-label label="Descripción" [tooltip]="descriptionFieldTooltip" />
          <lib-input label="" [value]="formDescription()" (valueChange)="formDescription.set($event)" />
        </app-grid-form-item>
        <app-grid-form-item [span]="'full'" class="admin-tenants__checkbox-field">
          <app-field-label label="Empresa activa" [tooltip]="activeFieldTooltip" />
          <lib-checkbox label="" [checked]="formActive()" (checkedChange)="formActive.set($event)" />
        </app-grid-form-item>
      </app-grid-form>
      <footer class="admin-tenants__dialog-footer">
        <lib-button variant="secondary" type="button" [disabled]="saving()" (clicked)="closeForm()">Cancelar</lib-button>
        <lib-button variant="primary" type="button" [loading]="saving()" (clicked)="saveTenant()">
          {{ formMode() === 'create' ? 'Crear' : 'Guardar cambios' }}
        </lib-button>
      </footer>
    </div>
  </div>
}
